'use client';

import { useSessionAuthenticate } from '@/hooks/use-session-authenticate';
import { AuthExtendedInfo, GetInfoResponse } from '@/server/api/v1/auth/types';
import { performSignOut } from '@/lib/perform-sign-out';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import CustomButton from '../custom-button';
import CustomDialog from '../custom-dialog';
import { CustomDialogType } from '../custom-dialog/custom-dialog';

type Props = {
    /**The data passed from server side */
    info: GetInfoResponse | null;
    extendedInfo: AuthExtendedInfo;
};

/**
 * Modal thông báo phiên đăng nhập đã hết hạn
 * @param session - The session passed from server side
 */
export function AuthenticationResolverDialog({ info, extendedInfo }: Props) {
    const transDef = useTranslations('System');
    const { isAuthenticated } = useSessionAuthenticate(info, extendedInfo);

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSignOut, setIsSignOut] = useState(false);

    const onGoOut = async () => {
        setIsSubmitting(true);
        setIsSignOut(true);
        const result = await performSignOut({ redirect: false });

        if (result?.url?.length) {
            // Full navigation sang /api/signout (KHÔNG reload trang hiện tại):
            // route handler xóa cookie session + kết thúc phiên SSO rồi 302 về trang đăng nhập.
            window.location.replace(result.url);
        } else {
            setIsSignOut(false);
        }
    };

    // Thông báo phiên đắng nhập đã hết hạn -> Vui lòng đăng nhập lại
    return (
        <CustomDialog
            type={CustomDialogType.Reponsive}
            dialogProps={{
                open: !isAuthenticated, //To do type of session
            }}
            trigger={<></>}
            headerTitle={<>{transDef('System_Alert')}</>}
            modalSize='lg'
            headerDescription={`${transDef('System_LoginSessionHasExpired')}. ${transDef('System_PleaseLoginAgain')}!`}
            footer={
                <CustomButton.Root
                    disabled={isSubmitting}
                    isLoading={isSignOut}
                    onClick={onGoOut}
                >
                    {transDef('System_Confirm')}
                </CustomButton.Root>
            }
        ></CustomDialog>
    );
}
